import { Slider } from "../../../components/slider";
import { RefObject } from "react";

const QuickSelectSlider = ({
  onQuantityChanged,
  maxTicketsPerUser,
  quantity,
  quantityInputRef,
  subscriptionMode = false,
}: {
  onQuantityChanged: (quantity: number) => void;
  maxTicketsPerUser: number;
  quantity: string;
  quantityInputRef: RefObject<HTMLInputElement>;
  subscriptionMode?: boolean;
}) => {
  const onValueChanged = (value: number[]) => {
    onQuantityChanged(value[0]);
    quantityInputRef.current.value = value[0].toString();
  };

  // With a single pass ticket min === max, so Radix renders the thumb at 0% (left).
  // There's nothing to drag, so show a static full track with the thumb at the right.
  const isSingleTicket = subscriptionMode && maxTicketsPerUser <= 1;

  return (
    <div data-name={"QuickSelectSlider"} className={"flex flex-col gap-4"}>
      <div className={`flex flex-col justify-end items-center gap-5 px-2 pt-2`}>
        <div className={"flex flex-col self-stretch gap-3"}>
          {isSingleTicket ? (
            <div className="relative flex w-full pb-6 items-center select-none">
              <div className="relative flex grow items-center min-h-5">
                <div className="bg-[#E7E7E7] grow overflow-hidden rounded-full h-1 w-full">
                  <div className="bg-primary h-full w-full" />
                </div>
                <span className="absolute right-0 top-1/2 -translate-y-1/2 pointer-events-none bg-white block size-5 shrink-0 rounded-full border-[3px] border-primary shadow-[0_3px_8px_0_rgba(0,0,0,0.30)]" />
              </div>
              <div className="absolute inset-x-0 bottom-0 flex items-center justify-between text-secondary font-jost text-xs font-normal leading-4">
                <span className="text-left">1</span>
                <span className="text-right">1</span>
              </div>
            </div>
          ) : (
            <Slider
              min={1}
              max={maxTicketsPerUser}
              step={1}
              value={[Number(quantity)]}
              minMaxPositionBottom={true}
              onValueChange={onValueChanged}
              showTooltip
              defaultValue={[Number(quantity)]}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default QuickSelectSlider;
